import { Form } from 'react-bootstrap';
import PropTypes from 'prop-types';
//components
import CustomInput from 'components/backoffice/customInput';
import SearchTable from 'components/backoffice/table/SearchTable';

const FiltersTableUsers = ({ formFilter, setFormFilter, handleClear, t, page, setPage }) => {
  const handleSearch = (e, key) => {
    if (page > 1 && e !== '') setPage(1);
    setFormFilter((prevFormFilter) => ({ ...prevFormFilter, [key]: e }));
  };

  return (
    <SearchTable handleClear={handleClear} multipleInput={true}>
      <Form className="d-flex flex-column flex-lg-row justify-content-between form-filter-list gap-3">
        <CustomInput
          handleKeyDown={true}
          type="text"
          value={formFilter.username}
          label={t('nombreusuario')}
          placeholder={t('nombreusuario')}
          onChange={(e) => handleSearch(e, 'username')}
        />
        <CustomInput
          handleKeyDown={true}
          type="text"
          value={formFilter.email}
          label={t('correoelectronico')}
          placeholder={t('correoelectronico')}
          onChange={(e) => handleSearch(e, 'email')}
        />
        <CustomInput
          handleKeyDown={true}
          type="text"
          value={formFilter.full_name}
          label={t('nombrecompleto')}
          placeholder={t('nombrecompleto')}
          onChange={(e) => handleSearch(e, 'full_name')}
        />
      </Form>
    </SearchTable>)
};

FiltersTableUsers.propTypes = {
  formFilter: PropTypes.object,
  handleClear: PropTypes.func,
  setFormFilter: PropTypes.func,
  t: PropTypes.func,
  page: PropTypes.number,
  setPage: PropTypes.func
};

export default FiltersTableUsers;
